/**
 * Initial presence for canvas rooms.
 *
 * Shared by the mounted canvas's RoomProvider (CanvasContext) and the
 * background room leases held by TabPreloadProvider: `client.enterRoom`
 * reference-counts by room id and only the FIRST enterer's options apply,
 * so every entry point must present the same initial presence.
 */
export const CANVAS_INITIAL_PRESENCE: Liveblocks["Presence"] = {
  cursor: null,
};
